import Vue from 'vue'
import App from './App.vue'
import router from './router'
import API from './api'
import '@/styles/base.less'
import '@/styles/base.css'
import 'lib-flexible/flexible'
import number from './utils/number'

Vue.config.productionTip = false

Vue.prototype.$API = API
Vue.prototype.$number = number

import './permission' // 路由权限

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
